import { countries } from './countries';

export const getCountryTranslations = (language: string) => {
  const translations: { [key: string]: { [key: string]: string } } = {
    fr: {
      selectCountry: 'Sélectionnez un pays',
      Afghanistan: 'Afghanistan',
      Albania: 'Albanie',
      Algeria: 'Algérie',
      Andorra: 'Andorre',
      Angola: 'Angola',
      'Antigua and Barbuda': 'Antigua-et-Barbuda',
      Argentina: 'Argentine',
      Armenia: 'Arménie',
      Australia: 'Australie',
      Austria: 'Autriche',
      Azerbaijan: 'Azerbaïdjan',
      Bahamas: 'Bahamas',
      Bahrain: 'Bahreïn',
      Bangladesh: 'Bangladesh',
      Barbados: 'Barbade',
      Belarus: 'Biélorussie',
      Belgium: 'Belgique',
      Belize: 'Belize',
      Benin: 'Bénin',
      Bhutan: 'Bhoutan',
      Bolivia: 'Bolivie',
      'Bosnia and Herzegovina': 'Bosnie-Herzégovine',
      Botswana: 'Botswana',
      Brazil: 'Brésil',
      Brunei: 'Brunei',
      Bulgaria: 'Bulgarie',
      'Burkina Faso': 'Burkina Faso',
      Burundi: 'Burundi',
      'Cabo Verde': 'Cap-Vert',
      Cambodia: 'Cambodge',
      Cameroon: 'Cameroun',
      Canada: 'Canada',
      'Central African Republic': 'République centrafricaine',
      Chad: 'Tchad',
      Chile: 'Chili',
      China: 'Chine',
      Colombia: 'Colombie',
      Comoros: 'Comores',
      Congo: 'Congo',
      'Congo (Democratic Republic)': 'République démocratique du Congo',
      'Costa Rica': 'Costa Rica',
      Croatia: 'Croatie',
      Cuba: 'Cuba',
      Cyprus: 'Chypre',
      'Czech Republic': 'République tchèque',
      Denmark: 'Danemark',
      Djibouti: 'Djibouti',
      Dominica: 'Dominique',
      'Dominican Republic': 'République dominicaine',
      Ecuador: 'Équateur',
      Egypt: 'Égypte',
      'El Salvador': 'Salvador',
      'Equatorial Guinea': 'Guinée équatoriale',
      Eritrea: 'Érythrée',
      Estonia: 'Estonie',
      Eswatini: 'Eswatini',
      Ethiopia: 'Éthiopie',
      Fiji: 'Fidji',
      Finland: 'Finlande',
      France: 'France',
      Gabon: 'Gabon',
      Gambia: 'Gambie',
      Georgia: 'Géorgie',
      Germany: 'Allemagne',
      Ghana: 'Ghana',
      Greece: 'Grèce',
      Grenada: 'Grenade',
      Guatemala: 'Guatemala',
      Guinea: 'Guinée',
      'Guinea-Bissau': 'Guinée-Bissau',
      Guyana: 'Guyana',
      Haiti: 'Haïti',
      Honduras: 'Honduras',
      Hungary: 'Hongrie',
      Iceland: 'Islande',
      India: 'Inde',
      Indonesia: 'Indonésie',
      Iran: 'Iran',
      Iraq: 'Irak',
      Ireland: 'Irlande',
      Israel: 'Israël',
      Italy: 'Italie',
      Jamaica: 'Jamaïque',
      Japan: 'Japon',
      Jordan: 'Jordanie',
      Kazakhstan: 'Kazakhstan',
      Kenya: 'Kenya',
      Kiribati: 'Kiribati',
      'Korea (North)': 'Corée du Nord',
      'Korea (South)': 'Corée du Sud',
      Kuwait: 'Koweït',
      Kyrgyzstan: 'Kirghizistan',
      Laos: 'Laos',
      Latvia: 'Lettonie',
      Lebanon: 'Liban',
      Lesotho: 'Lesotho',
      Liberia: 'Libéria',
      Libya: 'Libye',
      Liechtenstein: 'Liechtenstein',
      Lithuania: 'Lituanie',
      Luxembourg: 'Luxembourg',
      Madagascar: 'Madagascar',
      Malawi: 'Malawi',
      Malaysia: 'Malaisie',
      Maldives: 'Maldives',
      Mali: 'Mali',
      Malta: 'Malte',
      'Marshall Islands': 'Îles Marshall',
      Mauritania: 'Mauritanie',
      Mauritius: 'Maurice',
      Mexico: 'Mexique',
      Micronesia: 'Micronésie',
      Moldova: 'Moldavie',
      Monaco: 'Monaco',
      Mongolia: 'Mongolie',
      Montenegro: 'Monténégro',
      Morocco: 'Maroc',
      Mozambique: 'Mozambique',
      Myanmar: 'Myanmar',
      Namibia: 'Namibie',
      Nauru: 'Nauru',
      Nepal: 'Népal',
      Netherlands: 'Pays-Bas',
      'New Zealand': 'Nouvelle-Zélande',
      Nicaragua: 'Nicaragua',
      Niger: 'Niger',
      Nigeria: 'Nigeria',
      'North Macedonia': 'Macédoine du Nord',
      Norway: 'Norvège',
      Oman: 'Oman',
      Pakistan: 'Pakistan',
      Palau: 'Palaos',
      Palestine: 'Palestine',
      Panama: 'Panama',
      'Papua New Guinea': 'Papouasie-Nouvelle-Guinée',
      Paraguay: 'Paraguay',
      Peru: 'Pérou',
      Philippines: 'Philippines',
      Poland: 'Pologne',
      Portugal: 'Portugal',
      Qatar: 'Qatar',
      Romania: 'Roumanie',
      Russia: 'Russie',
      Rwanda: 'Rwanda',
      'Saint Kitts and Nevis': 'Saint-Kitts-et-Nevis',
      'Saint Lucia': 'Sainte-Lucie',
      'Saint Vincent and the Grenadines': 'Saint-Vincent-et-les Grenadines',
      Samoa: 'Samoa',
      'San Marino': 'Saint-Marin',
      'Sao Tome and Principe': 'Sao Tomé-et-Principe',
      'Saudi Arabia': 'Arabie saoudite',
      Senegal: 'Sénégal',
      Serbia: 'Serbie',
      Seychelles: 'Seychelles',
      'Sierra Leone': 'Sierra Leone',
      Singapore: 'Singapour',
      Slovakia: 'Slovaquie',
      Slovenia: 'Slovénie',
      'Solomon Islands': 'Îles Salomon',
      Somalia: 'Somalie',
      'South Africa': 'Afrique du Sud',
      'South Sudan': 'Soudan du Sud',
      Spain: 'Espagne',
      'Sri Lanka': 'Sri Lanka',
      Sudan: 'Soudan',
      Suriname: 'Suriname',
      Sweden: 'Suède',
      Switzerland: 'Suisse',
      Syria: 'Syrie',
      Taiwan: 'Taïwan',
      Tajikistan: 'Tadjikistan',
      Tanzania: 'Tanzanie',
      Thailand: 'Thaïlande',
      'Timor-Leste': 'Timor oriental',
      Togo: 'Togo',
      Tonga: 'Tonga',
      'Trinidad and Tobago': 'Trinité-et-Tobago',
      Tunisia: 'Tunisie',
      Turkey: 'Turquie',
      Turkmenistan: 'Turkménistan',
      Tuvalu: 'Tuvalu',
      Uganda: 'Ouganda',
      Ukraine: 'Ukraine',
      'United Arab Emirates': 'Émirats arabes unis',
      'United Kingdom': 'Royaume-Uni',
      'United States': 'États-Unis',
      Uruguay: 'Uruguay',
      Uzbekistan: 'Ouzbékistan',
      Vanuatu: 'Vanuatu',
      'Vatican City': 'Vatican',
      Venezuela: 'Venezuela',
      Vietnam: 'Viêt Nam',
      Yemen: 'Yémen',
      Zambia: 'Zambie',
      Zimbabwe: 'Zimbabwe'
    },
    es: {
      selectCountry: 'Seleccione un país',
      Afghanistan: 'Afganistán',
      Albania: 'Albania',
      Algeria: 'Argelia',
      Andorra: 'Andorra',
      Angola: 'Angola',
      'Antigua and Barbuda': 'Antigua y Barbuda',
      Argentina: 'Argentina',
      Armenia: 'Armenia',
      Australia: 'Australia',
      Austria: 'Austria',
      Azerbaijan: 'Azerbaiyán',
      Bahamas: 'Bahamas',
      Bahrain: 'Baréin',
      Bangladesh: 'Bangladés',
      Barbados: 'Barbados',
      Belarus: 'Bielorrusia',
      Belgium: 'Bélgica',
      Belize: 'Belice',
      Benin: 'Benín',
      Bhutan: 'Bután',
      Bolivia: 'Bolivia',
      'Bosnia and Herzegovina': 'Bosnia y Herzegovina',
      Botswana: 'Botsuana',
      Brazil: 'Brasil',
      Brunei: 'Brunéi',
      Bulgaria: 'Bulgaria',
      'Burkina Faso': 'Burkina Faso',
      Burundi: 'Burundi',
      'Cabo Verde': 'Cabo Verde',
      Cambodia: 'Camboya',
      Cameroon: 'Camerún',
      Canada: 'Canadá',
      'Central African Republic': 'República Centroafricana',
      Chad: 'Chad',
      Chile: 'Chile',
      China: 'China',
      Colombia: 'Colombia',
      Comoros: 'Comoras',
      Congo: 'Congo',
      'Congo (Democratic Republic)': 'República Democrática del Congo',
      'Costa Rica': 'Costa Rica',
      Croatia: 'Croacia',
      Cuba: 'Cuba',
      Cyprus: 'Chipre',
      'Czech Republic': 'República Checa',
      Denmark: 'Dinamarca',
      Djibouti: 'Yibuti',
      Dominica: 'Dominica',
      'Dominican Republic': 'República Dominicana',
      Ecuador: 'Ecuador',
      Egypt: 'Egipto',
      'El Salvador': 'El Salvador',
      'Equatorial Guinea': 'Guinea Ecuatorial',
      Eritrea: 'Eritrea',
      Estonia: 'Estonia',
      Eswatini: 'Esuatini',
      Ethiopia: 'Etiopía',
      Fiji: 'Fiyi',
      Finland: 'Finlandia',
      France: 'Francia',
      Gabon: 'Gabón',
      Gambia: 'Gambia',
      Georgia: 'Georgia',
      Germany: 'Alemania',
      Ghana: 'Ghana',
      Greece: 'Grecia',
      Grenada: 'Granada',
      Guatemala: 'Guatemala',
      Guinea: 'Guinea',
      'Guinea-Bissau': 'Guinea-Bisáu',
      Guyana: 'Guyana',
      Haiti: 'Haití',
      Honduras: 'Honduras',
      Hungary: 'Hungría',
      Iceland: 'Islandia',
      India: 'India',
      Indonesia: 'Indonesia',
      Iran: 'Irán',
      Iraq: 'Irak',
      Ireland: 'Irlanda',
      Israel: 'Israel',
      Italy: 'Italia',
      Jamaica: 'Jamaica',
      Japan: 'Japón',
      Jordan: 'Jordania',
      Kazakhstan: 'Kazajistán',
      Kenya: 'Kenia',
      Kiribati: 'Kiribati',
      'Korea (North)': 'Corea del Norte',
      'Korea (South)': 'Corea del Sur',
      Kuwait: 'Kuwait',
      Kyrgyzstan: 'Kirguistán',
      Laos: 'Laos',
      Latvia: 'Letonia',
      Lebanon: 'Líbano',
      Lesotho: 'Lesoto',
      Liberia: 'Liberia',
      Libya: 'Libia',
      Liechtenstein: 'Liechtenstein',
      Lithuania: 'Lituania',
      Luxembourg: 'Luxemburgo',
      Madagascar: 'Madagascar',
      Malawi: 'Malaui',
      Malaysia: 'Malasia',
      Maldives: 'Maldivas',
      Mali: 'Malí',
      Malta: 'Malta',
      'Marshall Islands': 'Islas Marshall',
      Mauritania: 'Mauritania',
      Mauritius: 'Mauricio',
      Mexico: 'México',
      Micronesia: 'Micronesia',
      Moldova: 'Moldavia',
      Monaco: 'Mónaco',
      Mongolia: 'Mongolia',
      Montenegro: 'Montenegro',
      Morocco: 'Marruecos',
      Mozambique: 'Mozambique',
      Myanmar: 'Myanmar',
      Namibia: 'Namibia',
      Nauru: 'Nauru',
      Nepal: 'Nepal',
      Netherlands: 'Países Bajos',
      'New Zealand': 'Nueva Zelanda',
      Nicaragua: 'Nicaragua',
      Niger: 'Níger',
      Nigeria: 'Nigeria',
      'North Macedonia': 'Macedonia del Norte',
      Norway: 'Noruega',
      Oman: 'Omán',
      Pakistan: 'Pakistán',
      Palau: 'Palaos',
      Palestine: 'Palestina',
      Panama: 'Panamá',
      'Papua New Guinea': 'Papúa Nueva Guinea',
      Paraguay: 'Paraguay',
      Peru: 'Perú',
      Philippines: 'Filipinas',
      Poland: 'Polonia',
      Portugal: 'Portugal',
      Qatar: 'Catar',
      Romania: 'Rumania',
      Russia: 'Rusia',
      Rwanda: 'Ruanda',
      'Saint Kitts and Nevis': 'San Cristóbal y Nieves',
      'Saint Lucia': 'Santa Lucía',
      'Saint Vincent and the Grenadines': 'San Vicente y las Granadinas',
      Samoa: 'Samoa',
      'San Marino': 'San Marino',
      'Sao Tome and Principe': 'Santo Tomé y Príncipe',
      'Saudi Arabia': 'Arabia Saudita',
      Senegal: 'Senegal',
      Serbia: 'Serbia',
      Seychelles: 'Seychelles',
      'Sierra Leone': 'Sierra Leona',
      Singapore: 'Singapur',
      Slovakia: 'Eslovaquia',
      Slovenia: 'Eslovenia',
      'Solomon Islands': 'Islas Salomón',
      Somalia: 'Somalia',
      'South Africa': 'Sudáfrica',
      'South Sudan': 'Sudán del Sur',
      Spain: 'España',
      'Sri Lanka': 'Sri Lanka',
      Sudan: 'Sudán',
      Suriname: 'Surinam',
      Sweden: 'Suecia',
      Switzerland: 'Suiza',
      Syria: 'Siria',
      Taiwan: 'Taiwán',
      Tajikistan: 'Tayikistán',
      Tanzania: 'Tanzania',
      Thailand: 'Tailandia',
      'Timor-Leste': 'Timor Oriental',
      Togo: 'Togo',
      Tonga: 'Tonga',
      'Trinidad and Tobago': 'Trinidad y Tobago',
      Tunisia: 'Túnez',
      Turkey: 'Turquía',
      Turkmenistan: 'Turkmenistán',
      Tuvalu: 'Tuvalu',
      Uganda: 'Uganda',
      Ukraine: 'Ucrania',
      'United Arab Emirates': 'Emiratos Árabes Unidos',
      'United Kingdom': 'Reino Unido',
      'United States': 'Estados Unidos',
      Uruguay: 'Uruguay',
      Uzbekistan: 'Uzbekistán',
      Vanuatu: 'Vanuatu',
      'Vatican City': 'Ciudad del Vaticano',
      Venezuela: 'Venezuela',
      Vietnam: 'Vietnam',
      Yemen: 'Yemen',
      Zambia: 'Zambia',
      Zimbabwe: 'Zimbabue'
    },
    pt: {
      selectCountry: 'Selecione um país',
      Afghanistan: 'Afeganistão',
      Albania: 'Albânia',
      Algeria: 'Argélia',
      Andorra: 'Andorra',
      Angola: 'Angola',
      'Antigua and Barbuda': 'Antígua e Barbuda',
      Argentina: 'Argentina',
      Armenia: 'Armênia',
      Australia: 'Austrália',
      Austria: 'Áustria',
      Azerbaijan: 'Azerbaijão',
      Bahamas: 'Bahamas',
      Bahrain: 'Bahrein',
      Bangladesh: 'Bangladesh',
      Barbados: 'Barbados',
      Belarus: 'Bielorrússia',
      Belgium: 'Bélgica',
      Belize: 'Belize',
      Benin: 'Benin',
      Bhutan: 'Butão',
      Bolivia: 'Bolívia',
      'Bosnia and Herzegovina': 'Bósnia e Herzegovina',
      Botswana: 'Botsuana',
      Brazil: 'Brasil',
      Brunei: 'Brunei',
      Bulgaria: 'Bulgária',
      'Burkina Faso': 'Burkina Faso',
      Burundi: 'Burundi',
      'Cabo Verde': 'Cabo Verde',
      Cambodia: 'Camboja',
      Cameroon: 'Camarões',
      Canada: 'Canadá',
      'Central African Republic': 'República Centro-Africana',
      Chad: 'Chade',
      Chile: 'Chile',
      China: 'China',
      Colombia: 'Colômbia',
      Comoros: 'Comores',
      Congo: 'Congo',
      'Congo (Democratic Republic)': 'República Democrática do Congo',
      'Costa Rica': 'Costa Rica',
      Croatia: 'Croácia',
      Cuba: 'Cuba',
      Cyprus: 'Chipre',
      'Czech Republic': 'República Tcheca',
      Denmark: 'Dinamarca',
      Djibouti: 'Djibuti',
      Dominica: 'Dominica',
      'Dominican Republic': 'República Dominicana',
      Ecuador: 'Equador',
      Egypt: 'Egito',
      'El Salvador': 'El Salvador',
      'Equatorial Guinea': 'Guiné Equatorial',
      Eritrea: 'Eritreia',
      Estonia: 'Estônia',
      Eswatini: 'Eswatini',
      Ethiopia: 'Etiópia',
      Fiji: 'Fiji',
      Finland: 'Finlândia',
      France: 'França',
      Gabon: 'Gabão',
      Gambia: 'Gâmbia',
      Georgia: 'Geórgia',
      Germany: 'Alemanha',
      Ghana: 'Gana',
      Greece: 'Grécia',
      Grenada: 'Granada',
      Guatemala: 'Guatemala',
      Guinea: 'Guiné',
      'Guinea-Bissau': 'Guiné-Bissau',
      Guyana: 'Guiana',
      Haiti: 'Haiti',
      Honduras: 'Honduras',
      Hungary: 'Hungria',
      Iceland: 'Islândia',
      India: 'Índia',
      Indonesia: 'Indonésia',
      Iran: 'Irã',
      Iraq: 'Iraque',
      Ireland: 'Irlanda',
      Israel: 'Israel',
      Italy: 'Itália',
      Jamaica: 'Jamaica',
      Japan: 'Japão',
      Jordan: 'Jordânia',
      Kazakhstan: 'Cazaquistão',
      Kenya: 'Quênia',
      Kiribati: 'Kiribati',
      'Korea (North)': 'Coreia do Norte',
      'Korea (South)': 'Coreia do Sul',
      Kuwait: 'Kuwait',
      Kyrgyzstan: 'Quirguistão',
      Laos: 'Laos',
      Latvia: 'Letônia',
      Lebanon: 'Líbano',
      Lesotho: 'Lesoto',
      Liberia: 'Libéria',
      Libya: 'Líbia',
      Liechtenstein: 'Liechtenstein',
      Lithuania: 'Lituânia',
      Luxembourg: 'Luxemburgo',
      Madagascar: 'Madagascar',
      Malawi: 'Malawi',
      Malaysia: 'Malásia',
      Maldives: 'Maldivas',
      Mali: 'Mali',
      Malta: 'Malta',
      'Marshall Islands': 'Ilhas Marshall',
      Mauritania: 'Mauritânia',
      Mauritius: 'Maurício',
      Mexico: 'México',
      Micronesia: 'Micronésia',
      Moldova: 'Moldávia',
      Monaco: 'Mônaco',
      Mongolia: 'Mongólia',
      Montenegro: 'Montenegro',
      Morocco: 'Marrocos',
      Mozambique: 'Moçambique',
      Myanmar: 'Myanmar',
      Namibia: 'Namíbia',
      Nauru: 'Nauru',
      Nepal: 'Nepal',
      Netherlands: 'Países Baixos',
      'New Zealand': 'Nova Zelândia',
      Nicaragua: 'Nicarágua',
      Niger: 'Níger',
      Nigeria: 'Nigéria',
      'North Macedonia': 'Macedônia do Norte',
      Norway: 'Noruega',
      Oman: 'Omã',
      Pakistan: 'Paquistão',
      Palau: 'Palau',
      Palestine: 'Palestina',
      Panama: 'Panamá',
      'Papua New Guinea': 'Papua Nova Guiné',
      Paraguay: 'Paraguai',
      Peru: 'Peru',
      Philippines: 'Filipinas',
      Poland: 'Polônia',
      Portugal: 'Portugal',
      Qatar: 'Catar',
      Romania: 'Romênia',
      Russia: 'Rússia',
      Rwanda: 'Ruanda',
      'Saint Kitts and Nevis': 'São Cristóvão e Nevis',
      'Saint Lucia': 'Santa Lúcia',
      'Saint Vincent and the Grenadines': 'São Vicente e Granadinas',
      Samoa: 'Samoa',
      'San Marino': 'San Marino',
      'Sao Tome and Principe': 'São Tomé e Príncipe',
      'Saudi Arabia': 'Arábia Saudita',
      Senegal: 'Senegal',
      Serbia: 'Sérvia',
      Seychelles: 'Seychelles',
      'Sierra Leone': 'Serra Leoa',
      Singapore: 'Singapura',
      Slovakia: 'Eslováquia',
      Slovenia: 'Eslovênia',
      'Solomon Islands': 'Ilhas Salomão',
      Somalia: 'Somália',
      'South Africa': 'África do Sul',
      'South Sudan': 'Sudão do Sul',
      Spain: 'Espanha',
      'Sri Lanka': 'Sri Lanka',
      Sudan: 'Sudão',
      Suriname: 'Suriname',
      Sweden: 'Suécia',
      Switzerland: 'Suíça',
      Syria: 'Síria',
      Taiwan: 'Taiwan',
      Tajikistan: 'Tajiquistão',
      Tanzania: 'Tanzânia',
      Thailand: 'Tailândia',
      'Timor-Leste': 'Timor-Leste',
      Togo: 'Togo',
      Tonga: 'Tonga',
      'Trinidad and Tobago': 'Trinidad e Tobago',
      Tunisia: 'Tunísia',
      Turkey: 'Turquia',
      Turkmenistan: 'Turcomenistão',
      Tuvalu: 'Tuvalu',
      Uganda: 'Uganda',
      Ukraine: 'Ucrânia',
      'United Arab Emirates':  'Emirados Árabes Unidos',
      'United Kingdom': 'Reino Unido',
      'United States': 'Estados Unidos',
      Uruguay: 'Uruguai',
      Uzbekistan: 'Uzbequistão',
      Vanuatu: 'Vanuatu',
      'Vatican City': 'Cidade do Vaticano',
      Venezuela: 'Venezuela',
      Vietnam: 'Vietnã',
      Yemen: 'Iêmen',
      Zambia: 'Zâmbia',
      Zimbabwe: 'Zimbábue'
    }
  };

  // For English, use the original country names
  if (language === 'en') {
    return countries.map(country => ({
      value: country.code,
      label: country.name
    }));
  }

  // For other languages, use translations if available, fallback to English
  return countries.map(country => ({
    value: country.code,
    label: translations[language]?.[country.name] || country.name
  }));
};